export default "__VITE_ASSET__CmG1jnDt__"